import { render, staticRenderFns } from "./areaStatistics.vue?vue&type=template&id=1224909b&scoped=true&"
import script from "./areaStatistics.vue?vue&type=script&lang=js&"
export * from "./areaStatistics.vue?vue&type=script&lang=js&"
import style0 from "./areaStatistics.vue?vue&type=style&index=0&id=1224909b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1224909b",
  null
  
)

export default component.exports